import Vue from 'vue'
import navigationBar from '@/components/navigationBar'
import { Loading } from "vant";

// register globally
Vue.component('navigationBar', navigationBar)

Vue.use(Loading)
